
export const caseStudies = {
  caseStudiesHero: {
    subtitle: 'CASE STUDIES',
    title: 'Implementation Cases',
  },
  empowerment: {
    title: 'EMPOWERMENT CODE ACADEMY',
    subtitle: 'Transforming Kindness into Unbreakable Strength',
    concept: 'Concept',
    conceptText: 'The reason many women hesitate despite wanting to change is not a lack of willpower. It lies in the \"cognitive structure\" unconsciously imprinted since childhood.',
    description1: 'EMPOWERMENT CODE ACADEMY is an educational institution that deciphers and redesigns women-specific thought patterns from the perspectives of neuroscience and behavioral psychology, rather than through motivational speeches or temporary excitement.',
    description2: 'We present a unique framework that elevates women\'s inherent \"compassion\" into \"flexible strength\" that moves society, without compromising it. From being protagonists swept away by emotional waves to becoming designers who freely manipulate the \"structure (CODE)\" of their own lives. A new educational standard that brings true autonomy and harmony begins here, from Japan to the world.',
    button: 'Inquire about this program',
  },
  quantum: {
    title: 'QUANTUM MEDICINE ACADEMY',
    titleKana: '',
    subtitle: 'Scientifically Understanding Mind-Body Structure and Redefining Life Performance',
    description: 'Quantum Medicine Academy integrates neuroscience, quantum theory, and behavioral psychology to systematize the interaction of human \"thought, emotion, and body.\" It is a practical educational institution that aims for fundamental reconstruction of survival strategies (behavioral patterns) through scientific training utilizing brain plasticity, rather than mere knowledge acquisition.',
    professionalPath: {
      label: 'PROFESSIONAL PATH',
      title: 'Quantum Medicine Therapist Department',
      description: 'Cultivating \"assessment ability\" and \"intervention design capability\" to become immediately effective in clinical settings. Building the next-generation standard for medical care and interpersonal support based on theories of mind-body correlation and autonomic nervous system regulation.',
    },
    selfOptimizationPath: {
      label: 'SELF-OPTIMIZATION PATH',
      title: 'Wellness Department',
      description: 'Toward the pinnacle of self-regulation. Acquiring techniques to scientifically reproduce sustainable high-performance states through breathing, posture, and emotional management.',
    },
    button: 'Inquire about this program',
  },
  corporate: {
    title: 'CORPORATE & SOCIAL SOLUTIONS',
    subtitle: 'Reproducible Transformation for Organizations and Society',
    description: 'From corporate training to next-generation educational support and nationwide seminars. We prove DREAM CODE theory as real-world transformation.',
    solutions: {
      training: {
        subtitle: 'Corporate Training',
        title: 'Corporate Training',
        description: 'Providing structural design programs for leadership development and productivity improvement.',
      },
      nextGen: {
        subtitle: 'Next Generation',
        title: 'Next-Generation Educational Support',
        description: 'Promoting \"structural thinking\" in educational settings and nurturing ambitious young people.',
      },
      seminars: {
        subtitle: 'National Seminars',
        title: 'National Seminars',
        description: 'Social contribution of DREAM CODE through workshops held throughout Japan.',
      },
    },
    bottomMessage: 'Because Japan has such achievements, international conference awards are inevitable. The fusion of theory and practice creates true transformation.',
  },
};
